import React from 'react';
import PropTypes from 'prop-types';
import getProvider from './providers';
import { withTitle } from '../../HOC';

const VideoRender = ({ provider, ...props }) => {
  const Provider = getProvider(provider);
  return <Provider {...props} />;
};

VideoRender.propTypes = {
  provider: PropTypes.string.isRequired
};

export default withTitle(VideoRender);
